import React from "react";
import useAllSettings from "./useAllSettings";
import secondaryComponents from "../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import { Outlet } from "react-router-dom";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { pathConstants } from "../../../../../routes/pathContants";

const AllSettings = () => {
  const { selectedMenuTab, setSelectedMenuTab, navigate } = useAllSettings();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Inventory - Receipt Settings"
      description={"Manage receipt customaization"}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.3 } }}
        className={`${globalStyles.pageColumnGaps}`}
      >
        <div className="mt-5">
          <h4 className="mb-0">Printer</h4>
          <p>
            {selectedMenuTab === "customization"
              ? "Configure Your Printer & customize your printouts"
              : "Configure Your Printer Settings"}
          </p>
        </div>
        <div className={globalStyles.rowNavigations}>
          {/* eslint-disable-next-line */}
          <a
            className={`${globalStyles.rowNavigations__item} ${
              selectedMenuTab === "configuration" ? globalStyles.active : ""
            }`}
            onClick={() => {
              if (selectedMenuTab !== "configuration") {
                setSelectedMenuTab("configuration");
                navigate(pathConstants.INVENTORY_PRINTER_CONFIGURATION, {
                  state: { menuTab: "configuration" },
                });
              }
            }}
          >
            Configuration
          </a>
          {/* eslint-disable-next-line */}
          <a
            className={`${globalStyles.rowNavigations__item} ${
              selectedMenuTab === "customization" ? globalStyles.active : ""
            }`}
            onClick={() => {
              if (selectedMenuTab !== "customization") {
                setSelectedMenuTab("customization");
                navigate(pathConstants.APP_RECEIPT_CUSTOMIZATION, {
                  state: { menuTab: "customization" },
                });
              }
            }}
          >
            Receipt Customization
          </a>
        </div>
        <Outlet />
      </motion.div>
    </secondaryComponents.MetaSetter>
  );
};

export default AllSettings;
